'use strict';

var _ = require('lodash');
var DynamicPricingAdjustmentsTooltipFactory = function DynamicPricingAdjustmentsTooltipFactory() {
  var tooltipContent = _.template(require('../templates/dynamic-pricing-adjustments-tooltip.html'));
  var HIDE_DELAY = 50;
  var SHOW_DELAY = 50;
  function DynamicPricingAdjustmentsTooltip() {}
  DynamicPricingAdjustmentsTooltip.constructor = DynamicPricingAdjustmentsTooltip;
  DynamicPricingAdjustmentsTooltip.prototype.getBuilder = function () {
    return function (cellData, wholeGridData) {
      var rowData = wholeGridData[cellData.row];
      if (rowData.dpAdjustments && rowData.dpAdjustmentClass) {
        var tooltipData = {
          dpAdjustments: rowData.dpAdjustments,
          dpAdjustmentClass: rowData.dpAdjustmentClass
        };
        return {
          htmlContent: tooltipContent(tooltipData),
          hideDelay: HIDE_DELAY,
          showDelay: SHOW_DELAY,
          placement: 'top'
        };
      } else {
        return '';
      }
    };
  };
  return DynamicPricingAdjustmentsTooltip;
};
module.exports = DynamicPricingAdjustmentsTooltipFactory;